import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import light from "@/styles/themes/light";

// vuetify-loader
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: { light },
    options: {
      customProperties: true,
    },
  },
});

export default vuetify;
